import React from 'react';

const Awards = ()=> (
    <div>
        <h2>Awards</h2>
        <p>The Organization Committee of DSLW 2022 is pleased to announce the following awards:</p>
        <ol type = "1">
         <li><b>The Best Student Paper Award:</b>
            <ul style={{listStyleType: "disc"}}>
                <li><b>The Best Student Paper Runner-up Award:</b> Jinu Gong, Osvaldo Simeone, Rahif Kassab, Joonhyuk Kang, "Forget-SVGD: Particle-Based Bayesian Federated Unlearning"</li>
                <li><b>The Best Student Paper Award:</b> Bishwadeep Das, Elvin Isufi, "Graph Filtering Over Expanding Graphs"</li>
            </ul>
         </li>

         <li><b>Audience Choice Awards:</b>
            <ul style={{listStyleType: "disc"}}>
                <li>Fernando Gama, Brendon G Anderson, Somayeh Sojoudi, "Node-Variant Graph Filters in Graph Neural Networks"</li>
                <li>Valentina Rizzello, Hanyi Zhang, Michael Joham, Wolfgang Utschick, "Compression Techniques for MIMO Channels in FDD Systems"</li>
                <li>Sara Shoouri, Mingyu Yang, Gordy Carichner, Yuyang Li, Ehab A Hamed, Angela Deng, Delbert A. Green, In Hee Lee, DAVID T BLAAUW, Hun Seok Kim, "Siamese Learning-based Monarch Butterfly Localization"</li>
                <li>Yongwei Wang, Lanjun Wang, Mingquan Feng, Rabab Ward, Z. Jane Wang, "Reaching a Better Trade-off Between Image Quality and Attack Success Rates in Transfer-based Adversarial Attacks"</li>
            </ul>
         </li>
        </ol>
    </div>
);

export default Awards;